import { render, staticRenderFns } from "./TutorialResource.vue?vue&type=template&id=5cdf9836&scoped=true"
import script from "./TutorialResource.vue?vue&type=script&lang=js"
export * from "./TutorialResource.vue?vue&type=script&lang=js"
import style0 from "./TutorialResource.vue?vue&type=style&index=0&id=5cdf9836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdf9836",
  null
  
)

export default component.exports